import { v4 as uuidv4 } from "uuid";
export class EntryUpComingEventSaveModel {
    constructor() {
        this.id = uuidv4();
        this.entryId = "";
        this.description = "";
        this.dueDateAsString = "";
    }
}
export default class EntryUpComingSaveEvent extends EntryUpComingEventSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
